{
    "common": {
        "or": "of",
        "logo_alt": "Logo",
        "loading": "Laden",
        "internet_restored": "Verbinding met internet hersteld",
        "internet_lost": "Verbinding met internet verbroken",
        "new_version_available": "Er is een nieuwe versie van de applicatie beschikbaar. De app wordt over 10 seconden bijgewerkt.",
        "app_updated": "Applicatie bijgewerkt naar de nieuwste versie."
    },
    "login": {
        "welcome": "Welkom! Hoe wil je inloggen?",
        "no_account": "Nieuw bij Medendo?",
        "start_trial_link": "Start je gratis proefperiode",
        "finish_setup_message": "Je account is klaar. Log in om tweestapsverificatie in te stellen.",
        "email_step": {
            "email_label": "Voer je e-mail in",
            "next_button": "Verder",
            "invalid_email": "Ongeldig e-mailadres"
        },
        "refer_to_email_step": {
            "message": "Er is een email verstuurd naar: <1>{{email}}</1><2/><3/>Volg de instructies in je email <4/>Je kunt dit venster sluiten."
        },
        "mfa_step": {
            "title": "Voer de verificatiecode in",
            "code_label": "Verificatiecode",
            "verify_button": "Verifiëren",
            "no_code_button": "Ik kan de code niet vinden",
            "error_expired": "De code is verlopen. Probeer het opnieuw.",
            "error_incorrect": "De code is onjuist. Probeer het opnieuw."
        },
        "mfa_setup_step": {
            "title": "Multi-Factor Authenticatie Setup",
            "setup_error": "Er is een fout opgetreden bij het instellen van TOTP. Probeer het opnieuw.",
            "verification_error": "De verificatiecode is onjuist. Probeer het opnieuw.",
            "finalize_error": "De verificatie is gelukt, maar het aanmelden is mislukt. Probeer het opnieuw.",
            "scan_instruction": "Scan deze QR Code met je authenticator app:",
            "manual_entry_instruction": "Of voer de onderstaande code handmatig in:",
            "code_input_instruction": "Voer de verificatiecode in:",
            "code_label": "Verificatiecode",
            "verify_button": "Verifiëren"
        },
        "password_step": {
            "title": "Wachtwoord",
            "password_label": "Voer je wachtwoord in",
            "login_button": "Inloggen",
            "forgot_password_button": "Wachtwoord vergeten?",
            "error_invalid_password": "Ongeldig wachtwoord. Probeer opnieuw.",
            "error_mfa_verify": "Er is een fout opgetreden bij het verifiëren van je account.",
            "error_send_email": "Er is een fout opgetreden bij het verzenden van de e-mail.",
            "error_send_reset_email": "Fout bij het verzenden van de e-mail",
            "reset_email_sent": "Een e-mail voor het opnieuw instellen van je wachtwoord is verzonden.",
            "sso_hint": "Jouw account gebruikt Google of Microsoft om in te loggen. Wachtwoord inloggen en wachtwoord herstel zijn niet beschikbaar.",
            "welcome_verify_email": "Welkom bij Medendo! 🚀 We sturen je eerst een <strong>e-mail</strong>, zodat je je eigen wachtwoord kunt instellen.",
            "send_email_button": "Email versturen"
        }
    },
    "account_disabled": {
        "title": "Je account is gedeactiveerd",
        "message": "Je hebt geen toegang meer tot Medendo.\nDenk je dat dit een fout is? Neem dan contact op met de verantwoordelijke voor de koppeling met het Medendo-systeem.",
        "logout_button": "Uitloggen"
    },
    "chat": {
        "title": "AI Chat",
        "collapse": "AI Chat verbergen",
        "expand": "AI Chat tonen",
        "expand_new_reply": "AI Chat tonen, nieuw antwoord",
        "replying": "AI Chat antwoordt",
        "assistant_title": "Assistent",
        "busy_try_again": "Even geduld. Ik ben nog bezig met het vorige verzoek.",
        "copy_message": "Bericht kopiëren",
        "fullscreen": "Volledig scherm",
        "exit_fullscreen": "Volledig scherm sluiten",
        "dropzone_hint": "Bestanden hier neerzetten om te uploaden",
        "parsing_file": "Inhoud van het bestand wordt geanalyseerd...",
        "placeholder": "Stel AI een vraag...",
        "attach_file": "Bestand bijvoegen",
        "send": "Verzenden",
        "disclaimer": "AI kan fouten maken. Raadpleeg onze gebruiksinstructies.",
        "action_create_report": "Verslag genereren",
        "action_modify_report": "Verslag wijzigen",
        "action_no_response": "Geen antwoord van de assistent op je vraag",
        "action_create_report_running": "Verslag wordt gemaakt...",
        "action_create_report_done": "Verslag gemaakt",
        "action_create_report_failed": "Verslag niet gemaakt",
        "action_modify_report_running": "Verslag wordt bijgewerkt...",
        "action_modify_report_done": "Verslag bijgewerkt",
        "action_modify_report_failed": "Verslag niet bijgewerkt",
        "changed_sections": "Bijgewerkt: {{sections}}",
        "changed_nothing": "Het verslag is ongewijzigd teruggekomen",
        "tool_other_running": "Using a tool...",
        "tool_other_done": "Used a tool",
        "tool_other_failed": "A tool failed",
        "tool_status_running": "bezig",
        "tool_status_done": "klaar",
        "tool_status_failed": "mislukt",
        "change_detected": "Gesprek gewijzigd"
    },
    "auth": {
        "where_is_code_title": "Waar is mijn code?",
        "code_explain_1": "Om in te loggen heb je een code nodig uit een Authenticator-app. Dit is een app op je telefoon die een extra beveiligingscode genereert.",
        "most_used_apps": "De meest gebruikte apps zijn:",
        "google_authenticator": "Google Authenticator",
        "microsoft_authenticator": "Microsoft Authenticator",
        "find_code_in_app": "Zoek op je telefoon naar één van deze apps en open deze. Je ziet een lijst met één of meerdere accounts. Zoek in de lijst naar een code met de naam medendo.",
        "enter_code": "Vul de code die bij medendo staat in om verder te gaan.",
        "no_code_contact": "Kun je geen code vinden? Neem dan contact op met onze support. Rechtsonder vind je een chatknop. Klik op deze om contact op te nemen.",
        "sign_up_with_google": "Aanmelden met Google",
        "log_in_with_google": "Inloggen met Google",
        "sign_up_with_microsoft": "Aanmelden met Microsoft",
        "log_in_with_microsoft": "Inloggen met Microsoft",
        "signin_failed": "Inloggen is niet mogelijk met het geselecteerde account.",
        "no_account_found": "Geen account gevonden voor dit e-mailadres. Meld je aan om te beginnen.",
        "no_account_found_no_signup": "Geen account gevonden voor dit e-mailadres.",
        "password_setup": {
            "title": "Kies een nieuw wachtwoord",
            "password_label": "Voer een nieuw wachtwoord in",
            "submit": "Wachtwoord instellen",
            "reset_failed": "Het is niet gelukt om je wachtwoord te resetten.",
            "success_message": "Je kunt nu inloggen met je nieuwe wachtwoord.",
            "go_to_login": "naar de inlog pagina"
        }
    },
    "signup": {
        "title": "Maak je account aan",
        "subtitle": "Start je gratis proefperiode bij Medendo",
        "email_label": "Vul je e-mailadres in",
        "password_label": "Kies een wachtwoord",
        "invalid_email": "Ongeldig e-mailadres",
        "weak_password": "Het wachtwoord moet minimaal {{min}} tekens bevatten",
        "password_hint": "Minimaal {{min}} tekens",
        "send_code_button": "Verstuur verificatiecode",
        "code_sent": "We hebben een 6-cijferige code gestuurd naar {{email}}. Vul deze hieronder in.",
        "redirecting_to_checkout": "E-mail geverifieerd, je wordt doorgestuurd naar de checkout...",
        "completing": "Je account wordt afgerond...",
        "complete_expired": "Deze checkoutlink is verlopen of niet voltooid. Begin opnieuw.",
        "code_label": "Verificatiecode",
        "verify_code_button": "Verifiëren",
        "invalid_code": "Die code is onjuist of verlopen",
        "resend_code": "Code opnieuw versturen",
        "resend_cooldown": "Opnieuw versturen over {{seconds}}s",
        "wrong_email": "Verkeerd e-mailadres? Begin opnieuw",
        "email_verified": "{{email}} is geverifieerd - maak nu je account af",
        "create_button": "Account aanmaken",
        "account_exists": "Je hebt al een account met dit e-mailadres. Log in plaats daarvan in.",
        "already_completed": "Je account is al aangemaakt. Log in plaats daarvan in.",
        "unavailable": "Aanmelden is nu niet mogelijk. Kom later terug.",
        "have_account": "Heb je al een account?",
        "go_to_login": "Log in",
        "error_generic": "Er ging iets mis bij het aanmelden. Probeer het opnieuw.",
        "checkout_cancelled": "De checkout is geannuleerd. Je kunt het opnieuw proberen wanneer je wilt.",
        "rate_limited": "Te veel pogingen. Wacht even en probeer het opnieuw.",
        "retry_button": "Probeer opnieuw",
        "first_name_label": "Voornaam",
        "last_name_label": "Achternaam",
        "name_required": "Vul je voor- en achternaam in",
        "toggle_password_visibility": "Wachtwoord tonen of verbergen",
        "trial_started": "Je proefperiode is gestart.",
        "continue_button": "Doorgaan"
    },
    "encounter": {
        "offline_too_long": "Offline te lang, opname gestopt. Klik op de knop \"opnieuw genereren\" om een verslag te maken.",
        "undo": "Ongedaan maken",
        "redo": "Opnieuw doen",
        "name": "Naam",
        "menu_record": "Nieuwe opname",
        "menu_history": "Gesprekken",
        "menu_templates": "Templates",
        "menu_admin": "Beheer",
        "menu_groups": "Groepen",
        "menu_settings": "Instellingen",
        "menu_open": "Menu",
        "menu_close": "Menu sluiten",
        "menu_integrations": "Integraties",
        "menu_support": "Support",
        "report": "Verslag",
        "report_field_empty": "Niets vastgelegd",
        "transcript_empty_title": "Nog geen transcript",
        "transcript_empty_body": "Start de opname en het gesprek verschijnt hier terwijl je praat",
        "report_empty_title": "Nog geen verslag",
        "report_empty_body": "Stop de opname en het verslag wordt uit het gesprek geschreven",
        "report_empty_body_no_permission": "Je account kan hier geen verslagen maken",
        "report_generating_body": "Het verslag wordt uit het gesprek geschreven…",
        "transcript": "Transcript",
        "template": "Template",
        "logout": "Uitloggen",
        "logout_confirm_title": "Uitloggen?",
        "logout_confirm_body": "Je wordt afgemeld op dit apparaat en gaat terug naar het inlogscherm.",
        "logout_confirm": "Uitloggen",
        "customer_portal": "Naar klantportaal",
        "customer_portal_error": "Er is iets misgegaan bij het openen van het klantportaal. Probeer het opnieuw.",
        "conversation_not_available": "Dit gesprek is niet langer beschikbaar.",
        "loading": "Laden...",
        "select_patient": "Selecteer cliënt",
        "client_locked_by_assistant": "Deze opname is gekoppeld aan {{name}}. Om met een andere cliënt te werken, moet je een nieuwe opname starten.",
        "client_locked_by_assistant_unnamed": "Deze opname is gekoppeld aan een cliënt. Om met een andere cliënt te werken, moet je een nieuwe opname starten.",
        "switch_to_patient_search": "Overschakelen naar cliëntenzoeker",
        "no_patients_found": "Geen cliënten gevonden",
        "no_patient": "Geen cliënt - typ een naam",
        "patient_id_duplicate_hint": "Cliënt-ID wordt getoond wanneer naam en geboortedatum niet uniek zijn.",
        "no_templates_message": "Je hebt een template nodig om een gesprek te starten",
        "no_templates_subtitle": "Kies er hierboven een, of stel er een in bij Templates.",
        "no_templates_action": "Naar templates",
        "no_care_plan_templates": "Geen templates beschikbaar voor deze cliënt",
        "care_plan_templates_load_error": "Kon de templates voor deze cliënt niet laden. Probeer het opnieuw.",
        "care_plan_template_resolve_error": "Kon de geselecteerde template niet laden. Probeer het opnieuw.",
        "in_person": "Fysiek",
        "online": "Online",
        "meeting_type": "Type gesprek",
        "start": "Opname starten",
        "stop": "Opname stoppen",
        "recording": "Opnemen...",
        "resume": "Hervatten",
        "leave_while_recording_title": "Nog aan het opnemen",
        "leave_while_recording": "Je bent nog aan het opnemen. Wil je deze pagina verlaten en de opname stoppen?",
        "sticky_panel": "Zwevend opnamepaneel",
        "copied": "Gekopieerd",
        "unknown": "onbekend",
        "submit_confirmation_title": "Bevestig verzending",
        "submit_confirmation_content": "Dit verslag wordt verzonden naar \"{{adapter}}\"{{patientName}}, weet je het zeker?",
        "for_patient": " voor cliënt \"{{name}}\"",
        "select_patient_first": "Selecteer eerst een cliënt",
        "send_report_to_adapter": "Verslag naar {{adapter}} verzenden",
        "cancel": "Annuleren",
        "confirm": "Bevestigen",
        "audio_errors": {
            "access_denied": "Medendo kon geen toegang krijgen tot de audiobron",
            "invalid_source": "De geselecteerde bron kan niet als audio-invoer worden gebruikt. Kies alsjeblieft een andere bron.",
            "no_mic_found": "Er is geen microfoon gevonden op je apparaat. Controleer of je microfoon is aangesloten en probeer het opnieuw",
            "mic_fallback_to_default": "Je geselecteerde microfoon is niet gevonden. In plaats daarvan wordt de standaardmicrofoon gebruikt. Kies indien nodig een andere.",
            "tab_capture_failed": "Voor het geselecteerde tabblad kan geen audio worden vastgelegd. Mogelijk heb je het verkeerde tabblad gekozen (er is daar geen audiotrack), of de browser blokkeert het vastleggen van audio van het geselecteerde tabblad.",
            "mic_not_supported": "Deze browser geeft geen toegang tot de microfoon, dus Medendo kan hier niet opnemen. Open Medendo in een andere browser en probeer het opnieuw.",
            "start_recording_error": "Er is een fout opgetreden bij het starten van de opname.",
            "upload_failed": "Fout bij uploaden van audiofragment {{number}}",
            "low_audio_level": "Het audioniveau is al een tijdje laag. Controleer je microfoon.",
            "recording_not_capturing": "Er is al enkele minuten niets opgenomen. Controleer je microfoon en start de opname opnieuw.",
            "recording_stopped_early": "Een opnamefragment stopte eerder dan verwacht. Controleer de transcriptie op hiaten.",
            "audio_source_lost_microphone": "De microfoon werkt niet meer. Medendo hervat de opname automatisch zodra deze weer is verbonden.",
            "audio_source_recovered_microphone": "De microfoon is weer verbonden. De opname gaat automatisch verder.",
            "audio_source_lost_screen": "Het gedeelde tabblad stuurt geen audio meer. Deel het tabblad opnieuw en start de opname opnieuw.",
            "audio_source_interrupted_microphone": "De microfoon is onderbroken. Mogelijk gebruikt een andere app hem.",
            "audio_source_interrupted_screen": "De audio van het gedeelde tabblad is onderbroken. Controleer of het tabblad nog speelt en gedeeld wordt.",
            "audio_source_added": "Er is een nieuwe microfoon aangesloten. Deze wordt niet gebruikt voor deze opname. Stop en start opnieuw om over te schakelen.",
            "recording_error": "Er is een fout opgetreden tijdens de opname.",
            "start_recording_failed": "Het starten van de opname is mislukt.",
            "session_start_failed": "Het is niet gelukt om een audio-opnamesessie te starten. Controleer je microfoon en/of werk je browser bij.",
            "upload_missing": "Geen bestand geüpload.",
            "no_transcription": "Geen transcriptie ontvangen.",
            "transcription_failed": "Transcriptie mislukt."
        },
        "copy_transcript_tooltip": "Kopieer de transcriptietekst naar het klembord",
        "copy_transcript": "Transcriptie kopiëren",
        "modify_report_tooltip": "Hiermee kun je aanpassingen aan het hele verslag toebrengen",
        "modify_report": "Verslag wijzigen",
        "modify_item_tooltip": "Hierdoor kunnen wijzigingen in dit rapportelement worden aangebracht",
        "modify_item": "Item wijzigen",
        "copy_report_tooltip": "Kopieer de rapporttekst naar het klembord",
        "copy_report": "Verslag kopiëren",
        "regenerate_report": "Verslag opnieuw genereren",
        "report_actions": "Verslagacties",
        "transcript_actions": "Transcriptacties",
        "send_report": "Verslag verzenden",
        "submit_report": "Verslag verzenden naar {{adapter}}",
        "confirm_edit": "Bewerk bevestigen",
        "delete": "Verwijderen",
        "select_date_tooltip": "Datum selecteren",
        "copy_error": "Fout bij kopiëren",
        "autosave_saving": "Opslaan…",
        "autosave_saved": "Opgeslagen",
        "autosave_error": "Je wijzigingen konden niet worden opgeslagen",
        "send_report_tooltip": "Rapport verzenden",
        "send_needs_ehr_template": "Deze template is niet gekoppeld aan {{adapter}}. Kies een {{adapter}}-template om het rapport te verzenden.",
        "report_submitted_message": "Rapport succesvol verzonden naar {{adapter}}",
        "recording_in_progress": "Opname loopt. Het transcript wordt regelmatig bijgewerkt en laat zien wie er spreekt.",
        "next_update_in": "Volgende update over",
        "transcribing_last_audio": "Bezig met het transcriberen van de laatste audio...",
        "participant": "Deelnemer",
        "identifying": "Spreker wordt herkend",
        "not_identified": "Niet-herkende deelnemer",
        "ai_dialog_title": "Wat kan ik voor je aanpassen?",
        "ai_dialog_placeholder": "Typ hier wat je wilt aanpassen...",
        "ai_dialog_input": "Aanpassingsinstructie",
        "ai_dialog_start_recording": "Spraakinvoer starten",
        "ai_dialog_stop_recording": "Spraakinvoer stoppen",
        "mic_access_denied": "Microfoon toegang geweigerd. Controleer je browserinstellingen.",
        "transcription_error": "Er is een fout opgetreden bij het transcriberen van de audio, probeer het alsjeblieft opnieuw.",
        "processing_transcription": "Bezig met verwerken...",
        "select_microphone": "Selecteer microfoon",
        "microphone_label": "Microfoon",
        "change_microphone_hint": "Stop de opname om van microfoon te wisselen.",
        "default_microphone": "Standaard",
        "no_microphone_found": "Geen microfoon gevonden",
        "mic_permission": {
            "title": "Microfoontoegang geblokkeerd",
            "instruction": "Toegang tot de microfoon voor deze site is geblokkeerd. Volg de onderstaande stappen om deze in te schakelen:",
            "step1": "Klik op het slot-icoon links van de adresbalk.",
            "step2": "Kies Site-instellingen.",
            "step3": "Zoek in de lijst naar Microfoon en stel in op Toestaan.",
            "step4": "Herlaad deze pagina om de instellingen toe te passen.",
            "close": "Sluiten"
        },
        "live_translation": {
            "title": "Live vertaling",
            "live": "Live",
            "toggle": "Live vertalen",
            "language_label_first": "Eerste taal",
            "language_label_second": "Tweede taal",
            "start_recording": "Start een opname om live te vertalen.",
            "original": "Origineel",
            "translated": "Vertaald",
            "error_refused": "Live vertaling is geweigerd. Mogelijk staat die ergens anders al open; sluit hem daar of probeer het later opnieuw.",
            "error_unavailable": "Live vertaling is nu niet beschikbaar. Zet hem uit en weer aan om het opnieuw te proberen.",
            "error_microphone": "Live vertaling kan de microfoon in deze browser niet gebruiken."
        }
    },
    "history": {
        "retention_hint_one": "Verwijderd {{count}} dag na de laatste wijziging",
        "retention_hint_other": "Verwijderd {{count}} dagen na de laatste wijziging",
        "sort_label": "Sorteren",
        "sort_newest": "Nieuwste eerst",
        "sort_oldest": "Oudste eerst",
        "sort_expiring": "Verloopt het eerst",
        "sort_name": "Naam A-Z",
        "sort_template": "Template A-Z",
        "sort_client": "Cliënt A-Z",
        "expires_in_one": "Verloopt over {{count}} dag",
        "expires_in_other": "Verloopt over {{count}} dagen",
        "no_client": "Geen cliënt",
        "no_template": "Geen template",
        "record_count_one": "{{count}} gesprek",
        "record_count_other": "{{count}} gesprekken",
        "today": "Vandaag",
        "yesterday": "Gisteren",
        "expires_today": "Verloopt vandaag",
        "expires_tomorrow": "Verloopt morgen",
        "search_placeholder": "Zoeken...",
        "no_results": "Geen gesprekken gevonden voor je zoekopdracht",
        "empty": "Nog geen gesprekken",
        "column_patient": "Cliënt",
        "column_template": "Template",
        "column_date": "Datum",
        "column_available_until": "Beschikbaar tot",
        "fetch_error": "Er is een fout opgetreden bij het ophalen van de geschiedenis.",
        "delete_confirm_title": "Gesprek verwijderen?",
        "delete_confirm": "Dit kan niet ongedaan worden gemaakt.",
        "delete": "Verwijderen",
        "cancel": "Annuleren",
        "delete_error": "Er is een fout opgetreden bij het verwijderen van het gesprek.",
        "actions_tooltip": "Gespreksacties",
        "offboarded_notice": "Je account is inactief, dus je kunt geen nieuwe opnames maken. Je kunt de verslagen en transcripties die nog niet verlopen zijn wel lezen. Kijk bij 'Beschikbaar tot'.",
        "renew_hint": "Wil je weer opnemen? Ga naar Instellingen om je abonnement te verlengen."
    },
    "admin": {
        "user_added_success": "Gebruiker succesvol toegevoegd.",
        "add_invalid_input": "E-mailadres of naam is onjuist.",
        "user_exists": "Gebruiker bestaat al.",
        "add_failed": "Fout bij het toevoegen van de gebruiker.",
        "user_updated_success": "Gebruiker succesvol bijgewerkt.",
        "user_update_failed": "Fout bij het bijwerken van de gebruiker.",
        "column_email": "E-mail",
        "column_permissions": "Rechten",
        "column_status": "Actief / Inactief",
        "select_all_on_page": "Selecteer alles op deze pagina",
        "previous_page": "Vorige",
        "next_page": "Volgende",
        "page_of": "Pagina {{page}} van {{total}}",
        "add_user_title": "Gebruiker toevoegen",
        "email_label": "E-mailadres",
        "given_name_label": "Voornaam",
        "family_name_label": "Achternaam",
        "cancel": "Annuleren",
        "add": "Toevoegen",
        "domain_mismatch_warning": "Let op: Het domein van dit e-mailadres wijkt af van jouw domein ({{domain}}).",
        "invalid_email_error": "Voer een geldig e-mailadres in",
        "user_already_exists_error": "Deze gebruiker bestaat al",
        "status_filter": "Status",
        "permission_filter": "Rechten",
        "all": "Alle",
        "status_active": "Actief",
        "status_inactive": "Inactief",
        "can_record": "Opnemen",
        "can_template": "Templates",
        "can_org_admin": "Beheerder",
        "batch_onboard_btn": "Lijst gebruikers toevoegen",
        "batch_offboard_btn": "Lijst gebruikers deactiveren",
        "n_selected": "{{count}} geselecteerd",
        "delete_tooltip": "Verwijderen",
        "clear_selection_tooltip": "Selectie wissen",
        "batch_status_success": "{{count}} gebruikers status aangepast naar {{status}}.",
        "batch_status_error": "Fout bij het aanpassen van status.",
        "batch_status_partial": "Niet alle gebruikers konden worden aangepast.",
        "file_too_large_admin": "Bestand is te groot. Maximum grootte is 1MB.",
        "file_process_error": "Fout bij het verwerken van het bestand. Probeer opnieuw.",
        "batch_onboard": "Batch onboarden",
        "batch_offboard": "Batch offboarden",
        "batch_operation": "Batch-bewerking",
        "processing_file": "Bestand wordt verwerkt... Dit kan even duren.",
        "close": "Sluiten",
        "no_users_in_file": "Geen gebruikers gevonden in het bestand.",
        "success_count": "Succes: {{count}}",
        "failed_count": "Mislukt: {{count}}",
        "confirm_n": "Bevestigen ({{count}})",
        "retry_failed_n": "Mislukte opnieuw proberen ({{count}})",
        "batch_delete_title": "Verwijderen bevestigen",
        "batch_delete_content": "Je gaat nu <strong>{{count}}</strong> {{userText}} verwijderen. Zij hebben dan geen toegang meer tot Medendo. Weet je zeker dat je ze wilt verwijderen?",
        "batch_delete_user": "gebruiker",
        "batch_delete_users": "gebruikers",
        "batch_delete_confirm": "Verwijderen",
        "fetch_error": "Fout bij het ophalen van gebruikers.",
        "permissions_updated_success": "Rechten succesvol aangepast.",
        "permissions_update_error": "Fout bij het aanpassen van de rechten.",
        "user_deactivated_success": "Gebruiker status aangepast naar INACTIEF.",
        "user_activated_success": "Gebruiker hersteld naar ACTIEF.",
        "user_restore_error": "Fout bij het herstellen van de gebruiker.",
        "no_users_selected": "Geen gebruikers geselecteerd.",
        "user_not_found": "Gebruiker niet gevonden.",
        "unknown_error": "Onbekende fout.",
        "batch_delete_success": "{{count}} gebruikers verwijderd.",
        "batch_delete_error": "Fout bij het verwijderen van gebruikers.",
        "batch_delete_partial": "Niet alle geselecteerde gebruikers konden worden verwijderd.",
        "batch_permissions_success": "{{count}} gebruikers aangepast.",
        "batch_permissions_error": "Fout bij het aanpassen van rechten.",
        "batch_permissions_partial": "Niet alle gebruikers konden worden aangepast.",
        "status_update_error": "Fout bij het aanpassen van de status.",
        "status_active_label": "ACTIEF",
        "status_inactive_label": "INACTIEF",
        "batch_onboard_server_error": "Er is een fout opgetreden tijdens het toevoegen."
    },
    "settings": {
        "title": "Instellingen",
        "language_label": "Taal",
        "locale_update_error": "Taal bijwerken mislukt.",
        "preferences_title": "Voorkeuren",
        "sounds_label": "Geluidseffecten",
        "your_groups": "Jouw groepen",
        "your_groups_empty": "Je bent nog geen lid van een groep.",
        "analytics_api_key": {
            "title": "Analytics API-key",
            "info": "Met deze sleutelcode krijg je toegang tot de Medendo Analytics API. De sleutelcode wordt maar één keer getoond en is daarna verborgen, bewaar hem dus goed. Als je de sleutelcode roteert dan wordt deze vervangen door een nieuwe en dan moeten integraties die de oude sleutelcode gebruiken worden bijgewerkt.",
            "active_label": "Actieve API key",
            "rotate": "Vernieuwen",
            "store_warning": "Sla deze API-key nu op, deze wordt niet opnieuw getoond.",
            "copy": "Kopiëren",
            "copied": "Analytics API-key gekopieerd naar klembord.",
            "copy_failed": "Kopiëren van analytics API-key mislukt.",
            "load_failed": "Laden van analytics API-key status mislukt.",
            "action_failed": "Analytics API-key actie mislukt.",
            "missing_error": "Er is geen analytics API-key geconfigureerd voor je organisatie. Neem contact op met support."
        },
        "account_title": "Account",
        "status_label": "Status",
        "status_inactive": "Inactief",
        "renew_explanation": "Je abonnement is beëindigd, dus je kunt alleen lezen wat je al hebt opgenomen. Verleng het om weer op te nemen.",
        "renew_button": "Abonnement verlengen",
        "renew_error": "Er is iets misgegaan bij het starten van je verlenging. Probeer het opnieuw."
    },
    "offboard": {
        "title": "Gebruiker deactiveren",
        "question": "Weet je zeker dat je deze gebruiker wilt deactiveren?",
        "cancel": "Annuleren",
        "confirm": "Bevestigen",
        "deleting": "Deactiveren..."
    },
    "templates": {
        "sort_favorites": "Favorieten eerst",
        "sort_name": "Naam A-Z",
        "sort_recent": "Recent gewijzigd",
        "sort_author": "Auteur A-Z",
        "group_favorites": "Favorieten",
        "group_all": "Alle templates",
        "template_count_one": "{{count}} template",
        "template_count_other": "{{count}} templates",
        "new": "Nieuw",
        "list_label": "Templates",
        "search_placeholder": "Zoeken...",
        "sort_label": "Sorteren",
        "author_header": "Auteur",
        "shared_with_header": "Gedeeld met",
        "modified_header": "Gewijzigd",
        "author_you": "Jij",
        "admins_only": "alleen beheerders",
        "no_results": "Geen templates gevonden voor je zoekopdracht.",
        "favorite_tooltip": "Templates die aan favorieten zijn toegevoegd, worden als eerste weergegeven bij het selecteren van een template voor een opname.",
        "manager": {
            "copy_suffix": " (kopie)",
            "imported_suffix": " (geïmporteerd)",
            "default_imported_name": "Geïmporteerd template"
        },
        "copy_tooltip": "Kopiëren",
        "download_tooltip": "Downloaden",
        "edit_tooltip": "Bewerken",
        "delete_tooltip": "Verwijderen",
        "delete_confirm_button": "Verwijderen",
        "delete_confirm_title": "Template verwijderen?",
        "delete_confirm": "Dit kan niet ongedaan worden gemaakt.",
        "cancel": "Annuleren",
        "read_file_error": "Kan bestandsinhoud niet lezen.",
        "import_success": "Template succesvol geïmporteerd.",
        "import_invalid": "Fout bij importeren van template. Is het een geldig JSON-bestand?",
        "create_dialog": {
            "title": "Kies een manier om een template te maken",
            "wizard": "Template Wizard",
            "import": "Importeren",
            "library": "Bibliotheek",
            "manual": "Handmatig",
            "library_description": "Kies zoveel templates als je wilt uit onze bibliotheek om te gebruiken als startpunt.<br/><br/>Je kunt met deze templates experimenteren hoe de Medendo workspace werkt, en ze vervolgens eenvoudig aanpassen aan jouw specifieke behoeften en interesses.",
            "library_button": "Kies uit bibliotheek",
            "wizard_description": "Upload een ingevuld voorbeeldverslag zoals je zelf maakt na een gesprek met een cliënt. Ondersteunde bestanden: .docx, .pdf, .txt.<br/><br/>AI zet dit om in een template dat je in Medendo kan gebruiken. Controleer anonimiteit.",
            "wizard_button": "Upload voorbeeld",
            "import_description": "Importeer een bestaand template van een .json bestand.",
            "import_button": "Upload .json",
            "manual_description": "Je kunt ook beginnen met een leeg template.<br/><br/>Kies deze optie als je geen goed voorbeeld document hebt of geen AI wilt gebruiken.",
            "manual_button": "Zelf maken",
            "cancel": "Annuleren"
        },
        "library": {
            "back": "Terug",
            "title": "Template Bibliotheek",
            "description": "Deze bibliotheek is een verzameling van veelvoorkomende templates uit verschillende zorgdisciplines. Als je een template ziet dat je wilt gebruiken dan kan je op de knop 'toevoegen' klikken om deze in jouw account beschikbaar te maken. Zodra het template in jouw account staat kan je het ook vrij bewerken.",
            "tabs": {
                "external": "Extern"
            },
            "search_placeholder": "Zoeken in bibliotheek...",
            "locale_filter_all": "Alle talen",
            "language_label": "Taal",
            "table": {
                "template": "Template",
                "description": "Beschrijving",
                "actions": "Acties"
            },
            "actions": {
                "add": "Toevoegen",
                "add_tooltip": "Voeg deze template toe aan je collectie",
                "in_templates": "In je templates",
                "import_success": "Template \"{{name}}\" succesvol toegevoegd.",
                "import_error": "Er is een fout opgetreden bij het importeren van de template",
                "fetch_error": "Er is een fout opgetreden bij het ophalen van de template bibliotheek."
            }
        },
        "external_library": {
            "search_placeholder": "Zoeken in {{adapter}} bibliotheek...",
            "search_placeholder_default": "adapter",
            "table": {
                "template": "Template",
                "description": "Beschrijving",
                "actions": "Acties"
            },
            "actions": {
                "add": "Toevoegen",
                "add_tooltip": "Voeg deze template toe aan je collectie",
                "in_templates": "In je templates",
                "import_success": "Template \"{{name}}\" succesvol toegevoegd.",
                "import_error": "Er is een fout opgetreden bij het importeren van de template"
            }
        },
        "view": {
            "back": "Terug",
            "download": "Download",
            "edit": "Bewerken",
            "name": "Naam:",
            "description": "Beschrijving:",
            "no_description": "Geen beschrijving beschikbaar",
            "items": "Items:",
            "no_description_fallback": "Geen beschrijving",
            "no_examples_fallback": "Geen voorbeelden"
        },
        "edit": {
            "back": "Terug",
            "sync": "Synchroniseren met EHR",
            "save": "Opslaan",
            "name_label": "Naam",
            "description_label": "Beschrijving",
            "keywords_label": "Trefwoorden",
            "keywords_info": "Voeg medische termen, namen of jargon toe die lastig te transcriberen zijn. Ze worden doorgegeven aan de spraak-naar-tekstengine om de herkenningsnauwkeurigheid voor deze template te verbeteren.",
            "keywords_placeholder": "bijv. quetiapine, sertraline, methylfenidaat: scheiden met spaties, komma's, punten of nieuwe regels",
            "items_header": "Items:",
            "add_item": "Nieuw item toevoegen",
            "item_name": "Naam",
            "item_type": "Type",
            "item_default_value": "Standaardtekst",
            "note_hint": "Deze tekst verschijnt ongewijzigd in het rapport. De AI past deze tekst niet aan.",
            "item_description": "Beschrijving",
            "item_examples": "Voorbeelden",
            "delete_item_tooltip": "Verwijder item",
            "copy_item_tooltip": "Kopieer item",
            "move_up_tooltip": "Verplaats omhoog",
            "move_down_tooltip": "Verplaats omlaag",
            "copy_suffix": " (kopie)",
            "sync_success": "{{count}} nieuwe items toegevoegd",
            "sync_updated": "Template gesynchroniseerd",
            "sync_updated_with_items": "Template gesynchroniseerd, {{count}} nieuwe items toegevoegd",
            "sync_up_to_date": "Template is al up-to-date",
            "sync_error": "Fout bij het synchroniseren van de template.",
            "magic_wand": "Template wijzigen",
            "magic_wand_tooltip": "Beschrijf wat je wilt veranderen en de AI past de template aan",
            "modifying_ai": "De AI past de template aan…",
            "modify_success": "De AI heeft de template aangepast",
            "modify_error": "Fout bij het wijzigen van de template.",
            "save_error_no_name": "Geef een naam voor de template.",
            "save_error_no_items": "Voeg minstens één item toe.",
            "save_success_updated": "Template is succesvol gewijzigd",
            "save_success_created": "Template is succesvol aangemaakt",
            "save_error_generic": "Fout bij het opslaan van de template.",
            "default_description": "Een chronologisch verslag van het gesprek met cliënt, patiënt en/of andere personen in een verhalende vorm.",
            "types": {
                "text": "Tekst",
                "number": "Nummer",
                "date": "Datum",
                "checkbox": "Selectievakje",
                "radiobutton": "Keuzerondje",
                "checkbox_group": "Selectievakjesgroep",
                "note": "Notitie"
            },
            "options_label": "Opties",
            "add_option": "Optie toevoegen",
            "option_placeholder": "Optie",
            "duplicate_option": "Deze optie bestaat al"
        },
        "share_manage": {
            "title": "Delen beheren",
            "not_shared": "Niet gedeeld",
            "all_members": "Alle leden",
            "admins_only": "Alleen beheerders",
            "no_rights": "Je hebt in geen enkele groep deelrechten. Beheerders en templatebeheerders kunnen templates delen.",
            "private_summary": "Deze template is alleen voor jou zichtbaar.",
            "shared_summary_one": "Gedeeld met {{count}} groep.",
            "shared_summary_other": "Gedeeld met {{count}} groepen.",
            "cancel": "Annuleren",
            "save": "Opslaan"
        },
        "share_dialog": {
            "title": "Template delen",
            "content": "Weet je zeker dat je \"{{templateName}}\" wilt delen met de groep \"{{groupName}}\"?",
            "cancel": "Annuleren",
            "confirm": "Delen"
        },
        "unshare_dialog": {
            "title": "Delen van template stoppen",
            "content": "Weet je zeker dat je \"{{templateName}}\" niet langer wilt delen met de groep \"{{groupName}}\"?",
            "cancel": "Annuleren",
            "confirm": "Delen stoppen"
        },
        "n_groups": "{{count}} groepen",
        "created_by": "Gemaakt door {{creator}}",
        "modified_ago": "gewijzigd {{time}}",
        "created_modified_tooltip": "Gemaakt {{created}} · laatste wijziging {{modified}}",
        "created_date": "Gemaakt {{date}}",
        "actions_tooltip": "Template-acties",
        "wizard_loading": {
            "elapsed_time": "Verstreken tijd: {{time}}",
            "please_wait": "Enkele minuten geduld alsjeblieft...",
            "messages": [
                "Bestand uploaden ...",
                "Document lezen ...",
                "Inhoud analyseren ...",
                "Template genereren ...",
                "Bijna klaar ..."
            ]
        }
    },
    "adapter": {
        "connection_error": "{{adapter}} is tijdelijk niet beschikbaar. Probeer het later opnieuw.",
        "reconnected": "Opnieuw verbonden met {{adapter}}.",
        "reconnect_required": "Je {{adapter}}-sessie is verlopen. Verbind opnieuw.",
        "reconnect_failed": "Kon niet opnieuw verbinden met {{adapter}}. Verbind opnieuw via Integraties.",
        "fetch_templates_error": "Kon templates niet laden van {{adapter}}.",
        "fetch_patients_error": "Kon cliënten niet laden van {{adapter}}.",
        "required_fields_one": "Het veld {{fields}} is verplicht en moet nog ingevuld worden.",
        "required_fields_other": "De velden {{fields}} zijn verplicht en moeten nog ingevuld worden."
    },
    "integrations": {
        "load_error": "Kon integraties niet laden",
        "init_error": "Kon verbinding niet starten",
        "launch": {
            "session_expired": "Sessie verlopen. Open Medendo opnieuw vanuit je EHR.",
            "config_error": "Kon EHR-sessie niet starten. Neem contact op met de beheerder."
        },
        "disconnect_confirm_title": "Verbinding met {{adapter}} verbreken?",
        "disconnect_confirm": "Je kunt op elk moment opnieuw verbinden.",
        "cancel": "Annuleren",
        "disconnect_success": "Verbinding verbroken",
        "disconnect_error": "Kon verbinding niet verbreken",
        "connected": "Verbonden",
        "not_connected": "Niet verbonden",
        "disconnect_btn": "Verbreek verbinding",
        "connect_btn": "Verbinden",
        "callback": {
            "invalid_parameters": "Ongeldige callback parameters",
            "success": "Integratie succesvol verbonden!",
            "error": "Kon integratie niet voltooien",
            "redirecting": "Je wordt doorgestuurd naar de integratiepagina...",
            "connecting": "Integratie verbinden...",
            "please_wait": "Even geduld terwijl we je integratie configureren."
        }
    },
    "errors": {
        "create_encounter": "Er is een fout opgetreden bij het aanmaken van de afspraak.",
        "update_encounter": "Er is een fout opgetreden bij het bijwerken van de afspraak.",
        "client_locked": "De cliënt kan niet meer worden gewijzigd: de assistent heeft de geschiedenis al opgehaald.",
        "generate_report": "Er is een fout opgetreden bij het genereren van het verslag.",
        "generate_transcript": "Er is een fout opgetreden bij het genereren van de transcriptie.",
        "update_field": "Er is een fout opgetreden bij het bijwerken van het veld.",
        "upload_file": "Er is een fout opgetreden bij het uploaden van het bestand.",
        "delete_file": "Er is een fout opgetreden bij het verwijderen van het bestand.",
        "send_message": "Er is een fout opgetreden bij het verzenden van het bericht.",
        "submit_report": "Er is een fout opgetreden bij het verzenden van het verslag.",
        "fetch_templates": "Er is een fout opgetreden bij het ophalen van de templates.",
        "fetch_groups": "Er is een fout opgetreden bij het ophalen van de groepen.",
        "copy_template": "Er is een fout opgetreden bij het kopiëren van de template.",
        "delete_template": "Er is een fout opgetreden bij het verwijderen van de template.",
        "sharing_updated": "Delen bijgewerkt.",
        "update_sharing": "Er is een fout opgetreden bij het bijwerken van het delen.",
        "logout": "Er is een fout opgetreden bij het uitloggen.",
        "user_info": "Er is een fout opgetreden bij het ophalen van de gebruikersinformatie.",
        "not_found_encounter": "De encounter kon niet worden gevonden.",
        "azure_policy_violation": "Het wijzigen is mislukt vanwege het inhoudsbeleid van Azure OpenAI. Probeer het opnieuw. Als het opnieuw mislukt, neem contact op met de ondersteuning.",
        "restricted_browser_environment": "Het lijkt erop dat je onze app hebt geopend in een beperkte browseromgeving. Open de app alsjeblieft in je browser.",
        "item_missing_in_template": "Het geselecteerde element ontbreekt in het template en kan niet worden gewijzigd (het template is mogelijk aangepast).",
        "file_too_large": "Bestand \"{{name}}\" is te groot. Het mag niet groter zijn dan {{maxMb}} MB.",
        "upload_success": "Bestand \"{{name}}\" succesvol geüpload.",
        "process_file_problem": "Er is een probleem opgetreden bij het verwerken van \"{{name}}\".",
        "template_not_found": "De gevraagde template ({{id}}) is niet voor je beschikbaar. Neem contact op met de verantwoordelijke voor de koppeling met het Medendo-systeem.",
        "patient_not_found": "De cliënt uit de koppeling ({{id}}) is niet voor je beschikbaar. Neem contact op met de verantwoordelijke voor de koppeling met het Medendo-systeem.",
        "update_favorite_failed": "Kon favoriet-status niet bijwerken.",
        "template_deleted": "Template succesvol verwijderd.",
        "copy_success": "Template succesvol gekopieerd.",
        "file_deleted_success": "Bestand \"{{name}}\" succesvol verwijderd.",
        "process_file_delete_problem": "Er is een probleem opgetreden bij het verwijderen van \"{{name}}\".",
        "unauthorized_refresh": "Ongeautoriseerd verzoek. Proberen token te vernieuwen...",
        "error_page": {
            "title": "Oeps! Er is iets misgegaan.",
            "default_message": "De pagina die je zoekt, kan niet worden gevonden of er is een andere fout opgetreden.",
            "unexpected_message": "Er is een onverwachte fout opgetreden. Ga terug naar de startpagina en probeer het opnieuw.",
            "back_home": "Terug naar de startpagina"
        }
    },
    "groups": {
        "title": "Groepen",
        "create_title": "Groep aanmaken",
        "name_label": "Groepsnaam",
        "description_label": "Beschrijving (optioneel)",
        "create_admin_note": "Je wordt de eerste beheerder van de groep. Voeg leden toe en deel templates zodra de groep is aangemaakt.",
        "create": "Aanmaken",
        "cancel": "Annuleren",
        "create_error": "Er is een fout opgetreden bij het aanmaken van de groep.",
        "created": "Groep \"{{name}}\" aangemaakt.",
        "no_groups": "Geen groepen beschikbaar.",
        "no_users_found": "Geen gebruikers gevonden.",
        "search_more_hint": "Eerste {{count}} resultaten worden getoond. Verfijn je zoekopdracht om meer te zien.",
        "tab_templates": "Templates",
        "template_visibility_group": "Alle leden",
        "template_visibility_admin": "Groepsbeheerders",
        "template_visibility_private": "Privé",
        "no_templates": "Nog geen templates gedeeld met deze groep.",
        "description": "Teams in je organisatie die templates delen.",
        "search_placeholder": "Groepen zoeken…",
        "search_members_placeholder": "Leden zoeken…",
        "all_groups": "Alle groepen",
        "new_group": "Nieuwe groep",
        "scope_group_admins_hint": "Alleen zichtbaar voor groepsbeheerders.",
        "view_only_hint": "Je kunt de leden van deze groep bekijken. Bewerken is beperkt tot groeps- en organisatiebeheerders.",
        "member_role_admin": "Beheerder",
        "member_role_member": "Lid",
        "add_member": "Lid toevoegen",
        "add_member_title": "Lid toevoegen",
        "add_member_search_label": "Gebruiker zoeken",
        "add": "Toevoegen",
        "no_members": "Geen leden in deze groep.",
        "fetch_members_error": "Er is een fout opgetreden bij het ophalen van leden.",
        "add_member_error": "Er is een fout opgetreden bij het toevoegen van het lid.",
        "remove_member_error": "Er is een fout opgetreden bij het verwijderen van het lid.",
        "update_member_error": "Er is een fout opgetreden bij het bijwerken van het lid.",
        "member_added": "Lid toegevoegd.",
        "member_removed": "Lid verwijderd.",
        "member_updated": "Ledenrechten bijgewerkt.",
        "scope_change_tooltip": "Wijzig wie dit kan zien",
        "open_template_tooltip": "Template openen",
        "integration_tooltip": "Hoort bij de {{name}}-integratie",
        "member_actions_tooltip": "Acties voor lid",
        "remove_from_group": "Uit groep verwijderen",
        "deleted": "Groep verwijderd.",
        "delete_error": "Er is een fout opgetreden bij het verwijderen van de groep.",
        "edit_title": "Groep bewerken",
        "save_changes": "Wijzigingen opslaan",
        "edit_hint": "Leden en templates worden niet beïnvloed: alleen hoe de groep wordt weergegeven.",
        "updated": "Groepsgegevens bijgewerkt.",
        "update_error": "Er is een fout opgetreden bij het bijwerken van de groep.",
        "add_member_note": "Nieuwe leden worden toegevoegd als Lid. Alleen een organisatiebeheerder kan iemand groepsbeheerder maken.",
        "member_you": "jij",
        "delete_dialog_title": "Groep '{{name}}' verwijderen?",
        "delete_body": "Templates die eraan zijn toegewezen worden privé van hun eigenaren. Dit kan niet ongedaan worden gemaakt.",
        "delete_affected_one": "1 gedeelde template en {{memberCount}} lidmaatschappen worden beïnvloed.",
        "delete_affected_other": "{{count}} gedeelde templates en {{memberCount}} lidmaatschappen worden beïnvloed.",
        "delete_confirm_button": "Groep verwijderen",
        "n_shared_one": "1 gedeelde template",
        "n_shared_other": "{{count}} gedeelde templates",
        "private_templates_section": "Je privé templates",
        "members_section_title": "Leden",
        "edit_action": "Bewerken",
        "n_members_one": "1 lid",
        "n_members_other": "{{count}} leden",
        "n_admins_one": "1 beheerder",
        "n_admins_other": "{{count}} beheerders",
        "n_template_admins_one": "1 templatebeheerder",
        "n_template_admins_other": "{{count}} templatebeheerders",
        "role_template_admin": "Templatebeheerder",
        "make_admin": "Beheerder maken",
        "make_template_admin": "Templatebeheerder maken",
        "make_member": "Rol instellen op Lid",
        "set_role_admin_title": "Beheerder maken?",
        "set_role_admin_body": "Diegene kan leden toevoegen of verwijderen, rollen instellen en het delen van templates voor deze groep beheren.",
        "set_role_admin_confirm": "Beheerder maken",
        "set_role_template_admin_title": "Templatebeheerder maken?",
        "set_role_template_admin_body": "Diegene kan templates met deze groep delen en het delen ervan ongedaan maken, naast gewoon lidmaatschap.",
        "set_role_template_admin_confirm": "Templatebeheerder maken",
        "set_role_member_title": "Instellen als lid?",
        "set_role_member_body": "Diegene behoudt het lidmaatschap maar kan alleen de groep en de gedeelde templates bekijken.",
        "set_role_member_confirm": "Instellen als lid",
        "no_matches": "Geen overeenkomsten",
        "no_results": "Geen resultaten"
    },
    "privacy_policy": {
        "title": "Privacyverklaring Medendo",
        "agree_checkbox": "Ik ga akkoord met de privacyverklaring",
        "agree_button": "Akkoord"
    },
    "usage_instructions": {
        "title": "Instructies voor verantwoord gebruik van Medendo",
        "agree_checkbox": "Ik heb de algemene instructies gelezen en begrepen",
        "agree_button": "Akkoord"
    },
    "user_agreement": {
        "title": "Algemene voorwaarden voor het gebruik van Medendo",
        "agree_checkbox": "Ik ga akkoord met de Algemene Voorwaarden",
        "agree_button": "Akkoord"
    }
}
